import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { store } from "app/store";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { router } from "common/router";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
